/*
 * STEP 12 OF 12 - the behaviour behind sections/wn-book-after.liquid.
 * Split out of that section on 20 Oct 2026 (Shopify's 16KB GraphQL document
 * limit). Settings arrive as data-wn-* attributes on [data-wn-book-after].
 * Read the section's header comment first.
 */
(function () {
  var band = document.querySelector('[data-wn-book-after]');
  if (!band) return;
  var base = band.getAttribute('data-wn-base') || '';
  var embed = band.querySelector('[data-wn-book-embed]');
  var frame = band.querySelector('[data-wn-book-iframe]');
  var opens = band.querySelectorAll('[data-wn-book-open]');
  var options = band.querySelectorAll('[data-wn-book-type]');
  var cta = band.querySelector('[data-wn-book-cta]');
  var currentType = '';
  var sendBox = band.querySelector('[data-wn-book-send]');
  var enqForm = document.querySelector('.wn-enquiry form')
             || (document.querySelector('[data-wn-submit]') || {}).form || null;
  var submitBtn = enqForm ? enqForm.querySelector('[data-wn-submit]') : null;
  var origin = base.replace(/^(https?:\/\/[^\/]+).*$/, '$1');

  function contact() {
    try { return JSON.parse(sessionStorage.getItem('wn-enq-contact') || '{}') || {}; } catch (e) { return {}; }
  }
  function urlFor(typeId) {
    // Private-safe form. See header: /appointment/<id>/calendar/any drops
    // private types back to the public list.
    var u = origin + '/?appointmentType=' + encodeURIComponent(typeId);
    var c = contact(), q = [];
    if (c.first) q.push('firstName=' + encodeURIComponent(c.first));
    if (c.last) q.push('lastName=' + encodeURIComponent(c.last));
    if (c.email) q.push('email=' + encodeURIComponent(c.email));
    if (c.phone) q.push('phone=' + encodeURIComponent(c.phone));
    return q.length ? u + '&' + q.join('&') : u;
  }
  function choose(btn, quiet) {
    for (var i = 0; i < options.length; i++) options[i].classList.toggle('is-checked', options[i] === btn);
    currentType = btn.getAttribute('data-wn-book-type') || '';
    var url = urlFor(currentType);
    frame.removeAttribute('loading');
    if (frame.getAttribute('src') !== url) frame.setAttribute('src', url);
    for (var k = 0; k < opens.length; k++) opens[k].setAttribute('href', url);
    embed.hidden = false;
    if (!quiet) embed.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  for (var i = 0; i < options.length; i++) {
    options[i].addEventListener('click', function () { choose(this); });
  }

  // The green button does not gate the calendar, it scrolls to it.
  if (cta) {
    cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (embed.hidden && options.length) { choose(options[0]); return; }
      embed.hidden = false;
      embed.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  var booked = false;
  var CONF_STEP = band.getAttribute('data-wn-conf-step') || '';
  var CONF_HEAD = band.getAttribute('data-wn-conf-head') || '';
  var CONF_TEXT = band.getAttribute('data-wn-conf-text') || '';
  var CONF_BANNER = band.getAttribute('data-wn-conf-banner') || '';

  // ---- META: THE EVENT THE ADS OPTIMISE ON --------------------------
  // Must mean "a consultation is in the diary", never a ring collection.
  // A custom name because Acuity's own Facebook integration fires Schedule
  // AND Purchase for EVERY appointment type. Emitted only here.
  function metaBooked() {
    try {
      if (typeof window.fbq !== 'function') return;
      var c = contact(), m = {}, has = false;
      if (c.email) m.em = String(c.email).toLowerCase().trim();
      if (c.first) m.fn = String(c.first).toLowerCase().trim();
      if (c.last) m.ln = String(c.last).toLowerCase().trim();
      if (c.phone) m.ph = String(c.phone).replace(/[^0-9]/g, '');
      for (var k in m) { if (Object.prototype.hasOwnProperty.call(m, k) && m[k]) has = true; }
      if (has && window.fbq.getState) {
        var st = window.fbq.getState();
        var pid = st && st.pixels && st.pixels.length ? st.pixels[0].id : '152810061798202';
        window.fbq('init', pid, m);
      }
      var eid = 'wn-booked-';
      try { eid += (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2, 10); }
      catch (e) { eid += Date.now(); }
      window.fbq('trackCustom', 'ConsultationBooked', {
        content_name: 'Bespoke consultation',
        content_category: 'Bespoke enquiry',
        appointment_type: currentType
      }, { eventID: eid });
    } catch (e) {}
  }

  // ---- KLAVIYO: so the chase can be automatic ------------------------
  // This is what answers "did they book?" now that the gate is off. Pair it
  // with Bespoke Enquiry Submitted in a flow. Phone is left off: Klaviyo
  // rejects a non-E.164 phone_number and drops the whole event.
  function klaviyoBooked() {
    try {
      var c = contact();
      if (!c.email) return;
      var attrs = { email: c.email };
      if (c.first) attrs.first_name = c.first;
      if (c.last) attrs.last_name = c.last;
      fetch('https://a.klaviyo.com/client/events/?company_id=Uc4DZa', {
        method: 'POST', mode: 'cors', keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: { 'Appointment type': currentType, 'Page': window.location.pathname },
          metric: { data: { type: 'metric', attributes: { name: 'Consultation Booked' } } },
          profile: { data: { type: 'profile', attributes: attrs } }
        } } })
      });
    } catch (e) {}
  }

  function showBookedState() {
    var wrap = band.querySelector('.wn-book12');
    if (wrap) wrap.classList.add('wn-book12--booked');
    var step = band.querySelector('[data-wn-book-step]');
    var head = band.querySelector('[data-wn-book-heading]');
    var hint = band.querySelector('[data-wn-book-hint]');
    if (step && CONF_STEP) step.textContent = CONF_STEP;
    if (head && CONF_HEAD) head.textContent = CONF_HEAD;
    if (hint && CONF_TEXT) hint.textContent = CONF_TEXT;

    var banner = document.querySelector('.wn-enquiry .alert-message.success span')
              || document.querySelector('.wn-enquiry .alert-message.success');
    if (banner && CONF_BANNER) banner.textContent = CONF_BANNER;
    if (banner && banner.scrollIntoView) {
      banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function markBooked() {
    if (booked) return;
    booked = true;
    metaBooked();
    klaviyoBooked();
    showBookedState();
  }

  // WHERE THE MESSAGE COMES FROM (measured 21 Oct, the whole reason the
  // confirmation never worked): Acuity runs the Custom Conversion Tracking
  // HTML in a SANDBOXED IFRAME ON ITS OWN DOMAIN, so it arrives from
  // https://conversion-tracking-sandbox.acuityinnovation.com - not the
  // scheduler. The old check dropped every one. Nothing was wrong in Acuity.
  var SELF = window.location.origin;
  function trusted(o) {
    if (o === SELF || o === origin) return true;
    return /^https:\/\/[a-z0-9-]+\.acuityinnovation\.com$/.test(o);
  }
  window.addEventListener('message', function (e) {
    if (band.hidden) return;   // nobody has reached step 12 yet
    if (!trusted(e.origin)) return;
    if (typeof e.data !== 'string' || e.data.indexOf('wn-booked') !== 0) return;
    markBooked();
  });

  function reveal() {
    if (!document.querySelector('.wn-enquiry .alert-message.success')) return;
    band.hidden = false;
    document.body.classList.add('wn-booking-open');
    if (options.length === 1) {
      band.querySelector('.wn-book12').classList.add('wn-book12--single');
      choose(options[0], true);
    }
  }

  function boot() {
    // THE GATE IS OFF (25 Oct 2026). From 21 Oct it held the enquiry back
    // until a time was booked, and it cost every single enquiry: Klaviyo,
    // 22-24 Oct, FIVE real people reached step 12, TWO booked a call, and
    // ZERO enquiries were submitted. Four of them were recovered only
    // because the gate banked the answers to Klaviyo first.
    //
    // The second click is not survivable. Tested with the submit button
    // OUTSIDE the form (HTML form="" attribute) and back INSIDE it: both
    // land on Shopify's "let us know you're not a robot" challenge. And
    // whether a visitor hits that challenge or simply never clicks Send
    // after Acuity's own big confirmation tick, the outcome is identical.
    //
    // So the enquiry posts at step 11 again - the configuration that worked
    // for a month - and "did they book?" is answered by the Klaviyo events
    // instead: Bespoke Enquiry Submitted, then Consultation Booked.
    // DO NOT re-arm a gate without a way to send that needs no second click.
    reveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();